import React, { ChangeEvent, useState } from 'react'
import { Modal } from 'react-responsive-modal'
import { BlockType } from '../../containers/LessonPage/types'
import { UpdateBlockDataType } from '../../containers/AdminLessonBlocksPage/types'
import {
  SortableContainer,
  SortableElement,
  SortableHandle,
} from 'react-sortable-hoc'
import { arrayMoveMutable, arrayMoveImmutable } from 'array-move'

// Styles
import './styles.scss'

const customModalStyles = {
  root: {
    zIndex: 99999,
  },
  overlay: {
    background: 'rgba(0, 0, 0, 0.4)',
  },
  modal: {
    width: 400,
    borderRadius: 20,
    padding: 20,
    margin: '2em',
    boxShadow: 'unset',
    overflow: 'unset',
    outline: 0,
    backgroundColor: '#FFF',
  },
}

export default ({
  blocks,
  onChange,
  onSort,
  onDelete,
  onClick,
  isProcess,
}: {
  blocks: BlockType[]
  onChange: (block_id: string, data: UpdateBlockDataType) => void
  onSort: (ids: string[]) => void
  onDelete: (block_id: string) => void
  onClick: (block_id: string) => void
  isProcess: boolean
}): JSX.Element => {
  if (!blocks.length) return <></>

  const initialRenameData = {
    modal: false,
    blockId: '',
    caption: '',
  }

  const initialDeleteData = {
    modal: false,
    blockId: '',
  }

  const ItemTypeMap = {
    gallery: 'Галерея',
    links: 'Ссылки',
    files: 'Файлы',
    notion: 'NotionDescription',
    'simple-task': 'Задание',
    videos: 'Видео',
  }

  const [renameData, setRenameData] = useState<{
    modal: boolean
    blockId: string
    caption: string
  }>(initialRenameData)

  const [deleteData, setDeleteData] = useState<{
    modal: boolean
    blockId: string
  }>(initialDeleteData)

  const handleCaptionChange = (target: ChangeEvent<HTMLInputElement>) => {
    renameData.caption = target.target.value
    setRenameData({ ...renameData })
  }

  const handleSendChange = () => {
    if (!renameData.caption) return
    onChange(renameData.blockId, {
      caption: renameData.caption,
    })
    setRenameData(initialRenameData)
  }

  const handleDeleteBlock = () => {
    onDelete(deleteData.blockId)
    setDeleteData(initialDeleteData)
  }

  const DragHandle = SortableHandle(() => (
    <div className={'admin-blocks__item-grab'} />
  ))

  const SortableItem = SortableElement(({ item }: { item: BlockType }) => (
    <div className={'admin-blocks__item'}>
      <div
        className={'admin-blocks__item-outer'}
        onClick={() => onClick(item.block_id)}
      />
      <div
        onClick={() =>
          setDeleteData({
            modal: true,
            blockId: item.block_id,
          })
        }
        className={'admin-blocks__item-remove'}
      />
      <DragHandle />
      <span
        onClick={() =>
          setRenameData({
            modal: true,
            blockId: item.block_id,
            caption: item.caption,
          })
        }
      >
        {item.caption}
      </span>
      <p>
        Тип: <b>{ItemTypeMap[item.type]}</b>
      </p>
      <p>
        Тег: <b>{item.tag || '-'}</b>
      </p>
    </div>
  ))

  const SortableList = SortableContainer(
    ({ items }: { items: BlockType[] }) => {
      return (
        <div>
          {items.map((item, index) => (
            <SortableItem
              key={item.block_id}
              index={index}
              item={item}
              disabled={isProcess}
            />
          ))}
        </div>
      )
    }
  )

  const onSortEnd = ({
    oldIndex,
    newIndex,
  }: {
    oldIndex: number
    newIndex: number
  }) => {
    const sortedIds = arrayMoveImmutable(blocks, oldIndex, newIndex).map(
      block => block.block_id
    )
    arrayMoveMutable(blocks, oldIndex, newIndex)
    onSort(sortedIds)
  }

  return (
    <div className={'admin-blocks'}>
      <SortableList
        lockAxis="y"
        lockToContainerEdges={true}
        lockOffset="0%"
        distance={1}
        items={blocks}
        onSortEnd={onSortEnd}
        useDragHandle={true}
      />
      <Modal
        open={renameData.modal}
        onClose={() => setRenameData(initialRenameData)}
        styles={customModalStyles}
        center={true}
      >
        <h3 style={{ margin: 0, marginBottom: 10 }}>Изменить название блока</h3>
        <input
          type={'text'}
          value={renameData.caption}
          onChange={handleCaptionChange}
          className={'admin-blocks__input'}
        />
        <button onClick={handleSendChange} className={'admin-blocks__button'}>
          Сохранить
        </button>
      </Modal>
      <Modal
        open={deleteData.modal}
        onClose={() => setDeleteData(initialDeleteData)}
        styles={customModalStyles}
        center={true}
      >
        <h3 style={{ margin: 0, marginBottom: 10 }}>
          Вы уверены, что хотите удалить?
        </h3>
        <button
          onClick={handleDeleteBlock}
          className={'admin-blocks__button'}
          style={{ background: '#E84E25', color: '#FFF' }}
        >
          Удалить
        </button>
      </Modal>
    </div>
  )
}
